import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import { 
  Dialog, 
  DialogContent, 
  DialogTitle, 
  FormLabel, 
  Grid,
  Stack, 
  TextareaAutosize, 
  TextField,
  Tabs,
  Tab,
  Tooltip,
  DialogActions
} from "@mui/material";
import {
  DataGrid,
  GridActionsCellItem,
} from "@mui/x-data-grid";
import EditNoteIcon from '@mui/icons-material/EditNote';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import format from "date-fns/format";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Chaser, GetUsers } from "../../Services/api";
import instance from "../../redux/api";
import {
  getAccountsList,
  getBrokerBranchesList,
  getCurrencyList,
} from "../../redux/slice/bankStatmentTransactionsSlice";
import { useStyles } from "../bankTransactions/bankTranscationContainerStyles";
import { CommonPaginationContainer, CommonSelect } from "../common";
import CustomDateRangePicker from "../common/CustomDateRangePicker";
import { CommonButton } from "../common/commonButton";
import { numberFormatter } from "../../utils/generalFunctions";
import { commonToast } from "../common";
import dayjs from 'dayjs';
import { getPaginationCount } from "../CashAllocation/utils";
// import { ViewAndEditBankTransaction } from "../CashTracker/ViewAndEditTxnDialog";

//styles
const ChaserText = {
  display: "flex",
  justifyContent: "space-between",
  fontWeight: "400",
  marginTop: 5,
};

const SummaryContainer = {
  display: "flex",
  justifyContent: "space-between",
  gap: "40px"
}

const SummaryText = {
  fontWeight: "bold"
}

const SummaryValue = {
  justifyContent: "flex-end"
}

const yellow = {
  height: "15px",
  width: "15px",
  borderRadius: "50%",
  backgroundColor:"rgb(255, 238, 0)",
  textAlign: "center"
}

const green = {
  height: "15px",
  width: "15px",
  borderRadius: "50%",
  backgroundColor:"rgb(1, 105, 13)",
  textAlign: "center"
}

const red = {
  height: "15px",
  width: "15px",
  borderRadius: "50%",
  backgroundColor:"rgb(255, 0, 0)",
  textAlign: "center"
}

const tooltipStyle = {
  backgroundColor: "#fff",
  color: '#3b3b3b',
  fontSize: '10px',
  border: '1px solid #3b3b3b',
  borderRadius: '0px',
  padding: '6px 6px',
  maxWidth: 300,
  whiteSpace: 'pre-line',
}

export default function ChaserContainer() {
  const toggle = useSelector((state) => state.toggleSideMenu);
  const { search } = useLocation();

  const dispatch = useDispatch();
  const location = useLocation();

  const [currentRow, setCurrentRow] = useState("");
  const [txnMode, setTxnMode] = useState("VIEW");
  const [isOpenTxnDialog, setIsOpenTxnDialog] = useState(false);

  const [fromDateValue, setFromDateValue] = useState("");
  const [toDateValue, setToDateValue] = useState("");
  const [brokerList, setBrokerList] = useState([]);
  const [users, setUsers] = useState([]);
  //styles
  const classes = useStyles();

  const getBrokerList = async () => {
    const response = await instance.get("documents/get_broker_list/");
    setBrokerList(response?.data?.Broker_Branch_Name);
  }

  useEffect(() => {
    // Fetch users data from an API
    instance
      .get(GetUsers)
      .then((data) => {
        const filteredUsers = data.data.filter(
          (user) => (user.role === "CC Processor" || user.role === "Lead Role") && user.status === "Active"
        );
        setUsers([...new Set(filteredUsers)]);
      })
      .catch((error) => {
        console.error("Error fetching users:", error);
      });
  }, []);

  const [searchFieldsPrams, setSearchFieldsPrams] = useState({
    Policy_No: "",
    allocated_date: "",
    Bank_Transaction_Id: "",
    Broker_Branch: "",
    Handler_Name: ""
  });

  const [isSearchPerformed, setIsSearchPerformed] = useState(false);
  const [isClearPerformed, setIsClearPerformed] = useState(false);
  const [isStatusDeSelected, setIsStatusDeSelected] = useState(false);

  //For pagination
  const [paginationCount, setPaginationCount] = useState(0);
  const [pageState, setPageState] = useState({
    isLoading: true,
    data: [],
    total: 0,
    page: 1,
    pageSize: 25,
  });

  const [openCommentsDialog, setOpenCommentsDialog] = useState(false);
  const [dialogCommentsValue, setDialogCommentsValue] = useState(null);
  const [originalComment, setOriginalComment] = useState("");
  const [shouldLoadData, setShouldLoadData] = useState(true);

  const [tabValue, setTabValue] = useState(2);

  // skip 0 means page 1
  const currentSkipNumber = () => {
    return pageState?.page === 1
      ? 0
      : pageState?.page === 0
        ? pageState?.page
        : pageState?.page - 1;
  };

  const Container = {
    width: toggle?.isOpen ? "calc(100vw - 305px)" : "calc(100vw - 100px)",
    display: "flex",
    flexDirection: "column",
    gap: 8,
  };

  // to clear search list if all filter fields are empty after search has been performed
  useEffect(() => {
    if (isSearchPerformed) {
      if (Object.values(searchFieldsPrams).every(value => !value) && fromDateValue === "" && toDateValue === "") {
        handleClearSearchList();
      }
    }
  }, [fromDateValue, toDateValue]);

  const [isAuditOpen, setIsAuditOpen] = useState(false);
  const handleActionButton = (currentRowData, currentTxnMode) => {
    setCurrentRow(currentRowData);
    setTxnMode(currentTxnMode);
    if (currentTxnMode == 'AUDIT') {
      setIsAuditOpen(true);
    } else { 
      setIsOpenTxnDialog(true);
    }
  };

  const handleCommentsOpenDialog = (currentRowCommentsData, rowId) => {
    setOpenCommentsDialog(true);
    setDialogCommentsValue(currentRowCommentsData || '');
    setOldConcatenatedComment(currentRowCommentsData || '');
    setCurrentRowId(rowId);
    setOriginalComment(currentRowCommentsData || '');
  };

  const handleCloseDialogs = () => {
    setOpenCommentsDialog(false);
    setDialogCommentsValue('');
    setOldConcatenatedComment('');
    setCurrentRowId(null);
    setIsAuditOpen(false);
  };

  const handleDialogInputChange = (e) => {
    const newValue = e.target.value;
    setDialogCommentsValue(newValue);
    const isModified = newValue !== originalComment;
    markRowAsModified(currentRowId, "comments", isModified, newValue);
  };

  const handleSaveComments = () => {
    setOpenCommentsDialog(false);

    // Only process if there's a new comment
    if (dialogCommentsValue) {

      // Mark the row as modified
      markRowAsModified(currentRowId, "comments", true, dialogCommentsValue);
      setOriginalComment(dialogCommentsValue);
    }

    handleCloseDialogs();
  };

  const [allocationType, setAllocationType] = useState("Query");
  const handleTabChange = async (_, newValue) => {
    setTabValue(newValue);
    setShouldLoadData(true);
    let selectedOption = newValue==0 ? "Allocated" : newValue==1 ? "Over Due" : "Query";
    setAllocationType(selectedOption);
    setPageState((old) => ({
      ...old,
      page: 1,
      pageSize: 25,
    }));
  };

  const [date1, setDate1] = useState("");
  const [date2, setDate2] = useState("");
  const [date3, setDate3] = useState("");
  const [escalationDate, setEscalationDate] = useState("");

  const handleDateChange = (type, value, currentRowId) => {
    const formattedDate = value ? value.format('DD-MM-YYYY') : '';
    if (type == "date1") {
      setDate1(formattedDate);
    } else if (type == "date2") {
      setDate2(formattedDate);
    } else if (type == "date3") {
      setDate3(formattedDate);
    } else {
      setEscalationDate(formattedDate);
    }
    markRowAsModified(currentRowId, "date", true, formattedDate);
  }

  // Track which rows have modified fields
  const [modifiedRows, setModifiedRows] = useState({});
  const [currentRowId, setCurrentRowId] = useState(null);
  const [oldConcatenatedComment, setOldConcatenatedComment] = useState("");

  // Function to get the current display value of a field
  const getDisplayValue = (rowId, fieldType, originalValue) => {
    // If the row has been modified and this field has been changed, return the modified value
    if (modifiedRows[rowId] && modifiedRows[rowId][fieldType] && modifiedRows[rowId][fieldType].modified) {
      return modifiedRows[rowId][fieldType].value;
    }
    // Otherwise return the original value
    return originalValue;
  };

  const { userData } = useSelector((state) => state?.user);
  // Function to check if a specific row has any modified fields
  const isRowModified = (rowId) => {
    return modifiedRows[rowId] !== undefined;
  };

  // Helper function to mark a row as modified and store current values
  const markRowAsModified = (rowId, fieldType, isModified, currentValue = null) => {
    setModifiedRows(prev => {
      // Create a new object to avoid mutation
      const newState = { ...prev };

      // Initialize the row if it doesn't exist
      if (!newState[rowId]) {
        newState[rowId] = {
          comments: { modified: false, value: null },
          date: { modified: false, value: null }
        };
      }

      // Update the specific field
      newState[rowId][fieldType] = {
        modified: isModified,
        value: currentValue
      };

      // If no fields are modified, remove the row
      if (!Object.values(newState[rowId]).some(field => field.modified)) {
        delete newState[rowId];
      }

      return newState;
    });
  };

  const columns = [
    {
      field: "historical",
      headerName: "",
      width: 15,
      headerAlign: "center",
      renderCell: (params) => (
        <>
          { params?.row?.indicator === 'Green' ? (
            <div style={green}></div>
          ) : params?.row?.indicator === 'Yellow' ? (
            <div style={yellow}></div>
          ) : (
            <div style={red}></div>
          )}
        </>
      ),
    },
    {
      field: "handler_name",
      headerName: "Handler Name",
      width: 120,
      headerAlign: "center",
      renderCell: (params) => (
        <Tooltip
          title={params?.row?.bank_transaction?.Assigned_User?.user_name}
          componentsProps={{
            tooltip: {
              sx: tooltipStyle,
            },
          }}
          placement="bottom-end"
          PopperProps={{
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [10, -10],
                },
              },
            ],
          }}
        >
          {params?.row?.bank_transaction?.Assigned_User?.user_name}
        </Tooltip>
      )
    },
    {
      field: "Bank_Transaction_Id",
      headerName: "Bank Transaction Id",
      width: 120,
      headerAlign: "center",
      renderCell: (params) => (
        <Tooltip
          title={params?.row?.bank_transaction?.Bank_Transaction_Id}
          componentsProps={{
            tooltip: {
              sx: tooltipStyle,
            },
          }}
          placement="bottom-end"
          PopperProps={{
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [10, -10],
                },
              },
            ],
          }}
        >
          {params?.row?.bank_transaction?.Bank_Transaction_Id}
        </Tooltip>
      )
      // renderCell: (params) => (
      //   <a
      //     href={`javascript:void(0)`}
      //     onClick={() =>
      //       handleActionButton(
      //         {
      //           ...params?.row?.bank_txn?.Bank_Transaction_Id,
      //           Real_Bank_Name: params?.row?.bank_txn?.bank_details?.bank_name,
      //         },
      //         "VIEW"
      //       )
      //     }
      //     // target="_blank"
      //     // rel="noopener noreferrer"
      //     style={{ color: "blue", cursor: "pointer" }}
      //   >
      //     {params?.row?.bank_txn?.Bank_Transaction_Id}
      //   </a>
      // ),
    },
    {
      field: "Broker_Branch",
      headerName: "Broker Branch",
      width: 200,
      headerAlign: "center",
      renderCell: (params) => (
        <Tooltip
          title={params?.row?.bank_transaction?.Broker_Branch}
          componentsProps={{
            tooltip: {
              sx: tooltipStyle,
            },
          }}
          placement="bottom-end"
          PopperProps={{
            modifiers: [
              {
                name: 'offset',
                options: {
                  offset: [10, -10],
                },
              },
            ],
          }}
        >
          {params?.row?.bank_transaction?.Broker_Branch}
        </Tooltip>
      )
    },
    {
      field: "policy_id",
      headerName: "Policy#",
      width: 120,
      headerAlign: "center",
      renderCell: (params) => (
        <a
          href={`javascript:void(0)`}
          onClick={() =>
            (window.location.href = `/cash-allocation?txn_id=${encodeURIComponent(params?.row?.bank_transaction?.Bank_Transaction_Id)}&policy_ref=${params?.row?.cash_allocation?.id}`)
          }
          rel="noopener noreferrer"
          role="button"
          style={{ color: "blue" }}
        >
          {params?.row?.cash_allocation?.policy_id}
        </a>
      ),
    },
    {
      field: "allocation_status",
      headerName: "Cash Allocation Status",
      width: 160,
      headerAlign: "center",
      renderCell: (params) => params?.row?.cash_allocation?.allocation_status ?? 0
    },
    {
      field: "receivable_amt",
      headerName: "Premium Due Amount",
      width: 150,
      headerAlign: "center",
      renderCell: (params) => (numberFormatter(params?.row?.cash_allocation?.receivable_amt ?? 0))
    },
    {
      field: "date1_value",
      headerName: "Query Date",
      width: 160,
      headerAlign: "center",
      renderCell: (params) => (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            value={params.value ? dayjs(params.value) : null}
            onChange={(newValue) => {
              handleDateChange("date1", newValue, params?.row?.id);
            }}
            disabled={params.value || params?.row?.date2_value || params?.row?.date3_value || params?.row?.escalation_date_value}
            format="DD/MM/YYYY"
            slotProps={{
              textField: {
                size: "small",
                fullWidth: true,
                variant: "standard"
              }
            }}
          />
        </LocalizationProvider>
      ),
    },
    {
      field: "date2_value",
      headerName: "Chaser 1",
      width: 160,
      headerAlign: "center",
      renderCell: (params) => (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            value={params.value ? dayjs(params.value) : null}
            onChange={(newValue) => {
              handleDateChange("date2", newValue, params?.row?.id);
            }}
            disabled={!params?.row?.date1_value || params?.row?.date2_value || params?.row?.date3_value || params?.row?.escalation_date_value}
            format="DD/MM/YYYY"
            minDate={dayjs(params?.row?.date1_value)}
            maxDate={dayjs(new Date())}
            slotProps={{
              textField: {
                size: "small",
                fullWidth: true,
                variant: "standard"
              }
            }}
          />
        </LocalizationProvider>
      ),
    },
    {
      field: "date3_value",
      headerName: "Chaser 2",
      width: 160,
      headerAlign: "center",
      renderCell: (params) => (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            value={params.value ? dayjs(params.value) : null}
            onChange={(newValue) => {
              handleDateChange("date3", newValue, params?.row?.id);
            }}
            disabled={!params?.row?.date1_value || !params?.row?.date2_value || params?.row?.date3_value || params?.row?.escalation_date_value}
            format="DD/MM/YYYY"
            minDate={dayjs(params?.row?.date2_value)}
            maxDate={dayjs(new Date())}
            slotProps={{
              textField: {
                size: "small",
                fullWidth: true,
                variant: "standard"
              }
            }}
          />
        </LocalizationProvider>
      ),
    },
    {
      field: "escalation_date_value",
      headerName: "Escalation Date",
      width: 160,
      headerAlign: "center",
      renderCell: (params) => (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            value={params.value ? dayjs(params.value) : null}
            onChange={(newValue) => {
              handleDateChange("escalation_date", newValue, params?.row?.id);
            }}
            disabled={!params?.row?.date1_value || !params?.row?.date2_value || !params?.row?.date3_value || params?.row?.escalation_date_value}
            format="DD/MM/YYYY"
            minDate={dayjs(params?.row?.date3_value)}
            maxDate={dayjs(new Date())}
            slotProps={{
              textField: {
                size: "small",
                fullWidth: true,
                variant: "standard"
              }
            }}
          />
        </LocalizationProvider>
      ),
    },
    {
      field: "comment",
      headerName: "Comments",
      headerAlign: "center",
      width: 130,
      renderCell: (params) => (
        <>
          {(userData?.role === "CC Processor" || userData?.role === "Manager") ? (
            <div
              onClick={() =>
                handleCommentsOpenDialog(
                  params?.row?.comments,
                  params.row.id
                )
              }
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  gap: 5,
                }}
              >
                <div
                  style={{
                    overflow: "hidden",
                    textWrap: "nowrap",
                  }}
                >
                  {getDisplayValue(
                    params.row.id,
                    "comments",
                    params?.row?.comments?.toLowerCase() === "nan"
                      ? ""
                      : params?.row?.comments
                  )}
                </div>
                <MoreHorizIcon />
              </div>
            </div>
          ) : (
            <div>
              {params?.row?.comments ?? "-"}
            </div>
          )}
        </>
      ),
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      flex: 1,
      minWidth: 100,
      description: "This column has a value getter and is not sortable.",
      cellClassName: "actions",
      getActions: ({ row }) => {
        let actionsList = [];
        actionsList.push(
          <CommonButton
              text="Save"
              handleClick={() => handleSave(row)}
              hoverColor="#EE3F00"
              disabled={!isRowModified(row.id)}
            />
        );
        actionsList.push(
          <GridActionsCellItem
            icon={
              <Tooltip title="Audit Trail">
                {" "}
                <EditNoteIcon />{" "}
              </Tooltip>
            }
            label="audit"
            className="textPrimary"
            onClick={() => handleActionButton(row, "AUDIT")}
            color="inherit"
          />
        );
        return actionsList;
      },
    }
  ];

  useEffect(() => {
    setPaginationCount(
      getPaginationCount(pageState?.total, pageState?.pageSize)
    );
  }, [pageState?.total]);

  const [historyData, setHistoryData] = useState({})

  const loadData = async () => {
    try {
      setPageState((old) => ({
        ...old,
        isLoading: true,
      }));

      let queryParams = `skip=${currentSkipNumber()}&pageSize=${pageState?.pageSize}&toggle_value=${allocationType}`;

      if (isSearchPerformed) {
        const getSearchQueryParam = searchQueryParams();
        if (getSearchQueryParam) {
          queryParams = `${queryParams}${getSearchQueryParam}`;
        }
      } else {
        // If we get information while performing route navigation
        if (!isClearPerformed) {
          let allocated = location?.state?.allocated || "";
          if (allocated) {
            queryParams = `${queryParams}&allocated=${allocated}`;
          }
          const policyNo = new URLSearchParams(search).get("policyNo");
          if (policyNo) {
            queryParams = `${queryParams}&policyNumber=${policyNo}`;
            setSearchFieldsPrams({
              ...searchFieldsPrams,
              Policy_No: policyNo,
            });
          }
        }
      }

      const response = await instance.get(`${Chaser}?${queryParams}`);

      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));

      if (response.status === 200) {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: response?.data?.data ?? [],
        }));
        setPaginationCount(
          Math.floor(response?.data?.count / pageState?.pageSize)
        );

        
        setHistoryData(response?.data?.summary)
      } else {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: [],
        }));
        setPaginationCount(0);
      }
    } catch (err) {
      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));
      setPaginationCount(0);
      console.error("err", err);
    }
  };

  const handleChaserFieldsInputChange = (name, value, reason) => {
    setSearchFieldsPrams({
      ...searchFieldsPrams,
      [name]: value?.trim(),
    });
    setIsStatusDeSelected(false);
    if (reason == "clear") {
      setSearchFieldsPrams({
        ...searchFieldsPrams,
        Bank_Allocation_Status: "",
      });
      setIsStatusDeSelected(true);
    }

    // to clear search list if all filter fields are empty after search has been performed
    if (isSearchPerformed && !value) {
      const searchFields = searchFieldsPrams;
      delete searchFields[name];
      if (Object.values(searchFields).every(value => !value) && fromDateValue === "" && toDateValue === "") {
        handleClearSearchList();
      }
    }
  };

  const handleEnter = (e) => {
    if (e.code === "Enter") {
      handleSearchChaserList();
    }
  };

  const searchQueryParams = () => {
    let getSearchQueryParams = "";

    const {
      Policy_No,
      Bank_Transaction_Id,
      Broker_Branch,
      Handler_Name,
    } = searchFieldsPrams;

    if (Policy_No) {
      getSearchQueryParams = `${getSearchQueryParams}&policyNumber=${Policy_No}`;
    }

    if (Bank_Transaction_Id) {
      getSearchQueryParams = `${getSearchQueryParams}&transactionId=${Bank_Transaction_Id}`;
    }

    if (Broker_Branch) {
      getSearchQueryParams = `${getSearchQueryParams}&brokerBranch=${Broker_Branch}`;
    }

    if (Handler_Name) {
      getSearchQueryParams = `${getSearchQueryParams}&handlerName=${Handler_Name}`;
    }

    let formattedFromDateValue = "",
      formattedToDateValue = "";

    if (fromDateValue && toDateValue) {
      formattedFromDateValue = format(fromDateValue, "yyyy-MM-dd");
      formattedToDateValue = format(toDateValue, "yyyy-MM-dd");
      getSearchQueryParams = `${getSearchQueryParams}&fromAllocationDate=${formattedFromDateValue}&toAllocationDate=${formattedToDateValue}`;
    }

    return getSearchQueryParams;
  };

  const handleSearchChaserList = async () => {
    try {
      let queryParams = `?skip=0&pageSize=${pageState?.pageSize}`;

      const getSearchQueryParam = searchQueryParams();
      if (getSearchQueryParam) {
        queryParams = `${queryParams}${getSearchQueryParam}`;
      }

      let allocated = location?.state?.allocated || "";
      if (allocated) {
        queryParams = `${queryParams}&allocated=${allocated}`;
      }

      if (
        location?.state?.fromDateValue &&
        location?.state?.toDateValue &&
        !queryParams.includes("fromAllocationDate")
      ) {
        let formattedFromDateValue = format(
          location?.state?.fromDateValue,
          "yyyy-MM-dd"
        );
        let formattedToDateValue = format(
          location?.state?.toDateValue,
          "yyyy-MM-dd"
        );
        queryParams = `${queryParams}&fromAllocationDate=${formattedFromDateValue}&toAllocationDate=${formattedToDateValue}`;
      }

      // set loading indicator
      setPageState((old) => ({
        ...old,
        isLoading: true,
      }));

      const response = await instance.get(`${Chaser}${queryParams}&toggle_value=${allocationType}`);
      {
        const data = response.data;
        setHistoryData(data?.summary)
      }
      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));

      if (response.status === 200) {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: response?.data?.data ?? [],
          page: 1,
        }));
        setIsSearchPerformed(true);
        setIsClearPerformed(false);
      } else {
        setPageState((old) => ({
          ...old,
          total: response?.data?.count,
          data: [],
        }));
        setPaginationCount(0);
      }
    } catch (error) {
      setPaginationCount(0);
      setPageState((old) => ({
        ...old,
        isLoading: false,
      }));
    }
  };

  const isFilterBtnDisable = () => {
    let disabled = true;
    const {
      Policy_No,
      Bank_Transaction_Id,
      Broker_Branch,
      Handler_Name
    } = searchFieldsPrams;
    if (
      Policy_No !== "" ||
      Bank_Transaction_Id !== "" ||
      Broker_Branch !== "" ||
      Handler_Name !== "" ||
      fromDateValue !== "" ||
      toDateValue !== ""
    ) {
      disabled = false;
    }

    return disabled;
  };

  const handleClearSearchList = async () => {
    setIsClearPerformed(true);
    setIsSearchPerformed(false);
    // clear fields
    setSearchFieldsPrams({
      Policy_No: "",
      Bank_Transaction_Id: "",
      Broker_Branch: "",
      Handler_Name:""
    });
    setFromDateValue("");
    setToDateValue("");
    setShouldLoadData(true)
  };

  const [isBrokerBranchSelected, setIsBrokerBranchSelected] = useState(false);
  const [isHandlerNameSelected, setIsHandlerNameSelected] = useState(false);

  // Handler for Bank Name Dropdown
  const handleBankNameDropdownChange = (name, value, reason) => {
    if (reason === "clear") {
      setIsBrokerBranchSelected(false);
      setIsHandlerNameSelected(false);
      setSearchFieldsPrams((prev) => ({
        ...prev,
        [name]: value,
      }));

      // to clear search list if all filter fields are empty after search has been performed
      if (isSearchPerformed && !value) {
        const searchFields = searchFieldsPrams;
        delete searchFields[name];
        if (Object.values(searchFields).every(value => !value) && fromDateValue === "" && toDateValue === "") {
          handleClearSearchList();
        }
      }
    } else {
      setIsBrokerBranchSelected(true);
      setIsHandlerNameSelected(true);
      setSearchFieldsPrams((prev) => ({ ...prev, [name]: value }));
    }
  };

  const [banksList, setBanksList] = useState([]);

  const getBanksList = async () => {
    const response = await instance.get("documents/get_all_unique_bank_names/");
    setBanksList(response?.data?.bank_names);
  };

  useEffect(() => {
    getBanksList();
  }, []);

  useEffect(() => {
    // Fetch Banks List
    dispatch(getAccountsList());
    // Fetch Broker branches
    dispatch(getBrokerBranchesList());
    // Fetch Currency Details
    dispatch(getCurrencyList());
    // Fetch broker branch
    getBrokerList();

    // load data
    if (shouldLoadData) {
      loadData();
      setShouldLoadData(false);
    }
  }, [allocationType, pageState?.pageSize, pageState?.page, shouldLoadData]);

  const handleSave = async (row) => {
    // Get the current state of all modifiable fields for this row
    const rowModifications = modifiedRows[row.id] || {};
    
    // current date in ISO format for Django
    const currentDate = new Date().toISOString();

    const payload = {};
    if (date1) {
      payload.date1_value = date1;
      payload.date1 = currentDate;
    }
    if (date2) {
      payload.date2_value = date2;
      payload.date2 = currentDate;
    } 
    if (date3) {
      payload.date3_value = date3;
      payload.date3 = currentDate;
    } 
    if (escalationDate) {
      payload.escalation_date_value = escalationDate;
      payload.escalation_date = currentDate;
    }

    try {
      Object.entries(rowModifications).forEach(([field, data]) => {
        if (data.modified) {
          payload[field] = data.value;
        }
      });

      // Add updated_by to payload
      payload.updated_by = userData?.id;

      let response;
      // if (row?.followup_data) {
      //   // If management record exists, use PATCH
      //   payload.id = row?.followup_data?.id;
      //   response = await instance.patch(
      //     `${Chaser}${row?.followup_data?.id}/`,
      //     payload
      //   );
      // } else {
      //   payload.bank_transaction = row?.bank_transaction?.id ?? ""
      //   payload.cash_allocation = row?.id ?? ""
      //   payload.query_status = row?.allocation_status ?? ""
      //   response = await instance.post(Chaser, payload);
      // }


      payload.id = row?.id;
      response = await instance.patch(
        `${Chaser}${row?.id}/`,
        payload
      );

      if (response?.status === 200 || response?.status === 201) {
        commonToast("success", "Changes saved successfully!");
        // Refresh the data
        setDate1("");
        setDate2("");
        setDate3("");
        setEscalationDate("");
        loadData();
      }
    } catch (error) {
      console.error("Error saving changes:", error);
      commonToast("error", "Failed to save changes");
    }

    // After saving, reset the modification flags for this row
    setModifiedRows(prev => {
      const newState = { ...prev };
      delete newState[row.id];
      return newState;
    });
  };

  const UserAuthorisation = userData?.user_permissions?.permissions_list['Chaser'];

  return (
    <div style={Container}>
      {UserAuthorisation?.["View"] === "Y" ? (
        <>
        <div>
          <div style={ChaserText}>
            <span style={{ color: "#FF5A01", fontSize: "24px" }}>
              Query Tracker
            </span>
          </div>
          <Grid style={{display: "flex"}}>
            <Grid container xs={9} lg={9} gap={"10px"}>
              <Grid
                container
                sx={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  mb: "5px",
                  mt: "30px",
                }}
                xs={12}
                lg={12}
                gap={"10px"}
              >
                <Grid
                  item
                  // xs={2}
                  md={3}
                  lg={2.65}
                  display={"flex"}
                  flexDirection={"column"}
                  gap={"2px"}
                >
                  <FormLabel>Transaction Id</FormLabel>
                  <TextField
                    value={searchFieldsPrams?.Bank_Transaction_Id}
                    onChange={(e) =>
                      handleChaserFieldsInputChange(
                        "Bank_Transaction_Id",
                        e.target.value
                      )
                    }
                    onKeyUp={(e) => handleEnter(e)}
                    sx={{ width: "auto" }}
                    size="small"
                  />
                </Grid>
                <Grid
                  item
                  display={"flex"}
                  flexDirection={"column"}
                  gap={"2px"}
                  // xs={2}
                  md={3}
                  lg={2.65}
                >
                  <FormLabel>Policy No</FormLabel>
                  <TextField
                    value={searchFieldsPrams?.Policy_No}
                    onChange={(e) =>
                      handleChaserFieldsInputChange(
                        "Policy_No",
                        e.target.value
                      )
                    }
                    onKeyUp={(e) => handleEnter(e)}
                    size="small"
                  />
                </Grid>
                <Grid
                  item
                  // xs={2.5}
                  md={3}
                  lg={2.65}
                  display={"flex"}
                  flexDirection={"column"}
                  gap={"4px"}
                >
                  <FormLabel>Broker Branch</FormLabel>
                  <CommonSelect
                    placeholder="Select Broker Branch"
                    value={searchFieldsPrams?.Broker_Branch ?? ""}
                    handleChange={(event, value, reason) =>
                      handleBankNameDropdownChange("Broker_Branch", value, reason, event)
                    }
                    options={brokerList || []}
                  />
                </Grid>

                <Grid
                  item
                  // xs={2.5}
                  md={3}
                  lg={2.65}
                  display={"flex"}
                  flexDirection={"column"}
                  gap={"4px"}
                >
                  <FormLabel>Handler Name</FormLabel>
                  <CommonSelect
                    placeholder="Select Handler Name"
                    value={searchFieldsPrams?.Handler_Name ?? ""}
                    handleChange={(event, value, reason) =>
                      handleBankNameDropdownChange("Handler_Name", value, reason, event)
                    }
                    options={userData?.role === "CC Processor" ? [`${userData?.user_name}`] : users?.map((option) => option?.user_name) || []}
                  />
                </Grid>

                {/* Allocate Date and Payment RCV Date on Same Line */}
                <Grid
                  item
                  // xs={2}
                  md={4}
                  lg={3}
                  display={"flex"}
                  flexDirection={"column"}
                  gap={"4px"}
                >
                  <FormLabel>Allocated Date</FormLabel>
                  <CustomDateRangePicker
                    startDate={fromDateValue}
                    setStartDate={setFromDateValue}
                    endDate={toDateValue}
                    setEndDate={setToDateValue}
                    maxDate={new Date()}
                  />
                </Grid>
              </Grid>

              <Grid
                container
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  alignContent: "space-between"
                }}
                // xs={12}
                // gap={"10px"}
              >
                {/* Search and Clear Buttons in a Separate Line */}
                <Grid
                  item
                  xs={5}
                  display={"flex"}
                  flexDirection={"row"}
                  gap={"2px"}
                  mt={"10px"}
                >
                  <FormLabel></FormLabel>
                  <CommonButton
                    text="Search"
                    className="bankStatementBtn"
                    handleClick={handleSearchChaserList}
                    hoverColor="#EE3F00"
                    disabled={pageState?.isLoading || isFilterBtnDisable()}
                  />

                  <FormLabel></FormLabel>
                  <CommonButton
                    text="Clear"
                    handleClick={handleClearSearchList}
                    className="bankStatementBtn"
                    hoverColor="#EE3F00"
                    disabled={pageState?.isLoading || isFilterBtnDisable()}
                  />
                </Grid>
                <Grid
                  item
                  xs={5}
                  display={"flex"}
                  flexDirection={"row"}
                  gap={"2px"}
                  mt={"10px"}
                  mr={"20px"}
                  justifyContent="flex-end"
                >
                  <Tabs
                    value={tabValue}
                    onChange={handleTabChange}
                    style={{
                      border: "1px solid black",
                      borderRadius: "10px",
                    }}
                    aria-label="disabled tabs example"
                  >
                    <Tab
                      label="Allocated"
                      style={{
                        borderRight: "1px solid black",
                        backgroundColor: tabValue === 0 ? "#FF5A01" : "",
                        color: tabValue === 0 ? "black" : "",
                      }}
                    />
                    <Tab
                      label="Over Due"
                      style={{
                        borderRight: "1px solid black",
                        backgroundColor: tabValue === 1 ? "#FF5A01" : "",
                        color: tabValue === 1 ? "black" : "",
                        // paddingLeft: "2px",
                      }}
                    />
                    <Tab
                      label="Query"
                      style={{
                        backgroundColor: tabValue === 2 ? "#FF5A01" : "",
                        color: tabValue === 2 ? "black" : "",
                        // paddingLeft: "2px",
                      }}
                    />
                  </Tabs>
                </Grid>
              </Grid>
            </Grid>
            <Grid xs={3} lg={3} style={{ display: 'flex', flexDirection:'column', gap: '5px', backgroundColor: 'lightgray', borderRadius: '10px', padding: '5px' }}>
              <div style={SummaryContainer}>
                <span style={SummaryText}>Total in Query Status:</span><span style={SummaryValue}>{historyData?.query_status ?? 0}</span>
              </div>
              <div style={SummaryContainer}>
              <span style={SummaryText}>Total in Premium Due Amt:</span>
              <span style={SummaryValue}>
                {numberFormatter(
                  typeof historyData?.premium_due_amount === "number" && !isNaN(historyData.premium_due_amount)
                    ? historyData.premium_due_amount
                    : 0
                )}
              </span>
              </div>
              <div style={SummaryContainer}>
                <span style={SummaryText}>In 1st follow up:</span><span style={SummaryValue}>{historyData?.in_date2 ?? 0}</span>
              </div>
              <div style={SummaryContainer}>
                <span style={SummaryText}>In 2nd follow up:</span><span style={SummaryValue}>{historyData?.in_date3 ?? 0}</span>
              </div>
              <div style={SummaryContainer}>
                <span style={SummaryText}>In escalation:</span><span style={SummaryValue}>{historyData?.in_escalation ?? 0}</span>
              </div>
            </Grid>
          </Grid>
        </div>
        <div 
          style={{
            height: "calc(100vh - 296px)",
            position: "relative",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div
            style={{
              height: "calc(100vh - 296px)",
              position: "relative",
              display: "flex",
              flexDirection: "row-reverse",
            }}
          >
            <DataGrid
              className={classes.pagination}
              loading={pageState?.isLoading}
              rows={pageState?.data ?? []}
              columns={columns}
              rowCount={pageState?.total}
              keepNonExistentRowsSelected
              disableSelectionOnClick
              pagination
              paginationMode="server"
              getRowId={(row) => row?.id}
              page={pageState.page - 1}
              pageSize={pageState?.pageSize ?? 25}
              rowsPerPageOptions={[10, 25, 50, 100]}
              onPageSizeChange={(newPageSize) => {
                setPageState((old) => {
                  setPaginationCount(
                    getPaginationCount(pageState?.total, newPageSize)
                  );
                  return { ...old, pageSize: newPageSize, page: 1 };
                });
                setShouldLoadData(true);
              }}
              sx={{
                "& .css-123glz5-MuiButtonBase-root-MuiCheckbox-root.Mui-checked": {
                  color: "black !important",
                },
                "& .MuiDataGrid-columnHeader[data-field='Assigned_Users']": {
                  minWidth: toggle?.isOpen
                    ? "160.137px !important"
                    : "160.137px !important",
                },
              }}
              // disableColumnFilter
              // disableColumnSelector
              // disableDensitySelector
              // disableColumnMenu
              slotProps={{
                toolbar: {
                  showQuickFilter: true,
                },
              }}
            />
            <Stack
              style={{
                position: "absolute",
                bottom: "8px",
              }}
            >
              <CommonPaginationContainer
                count={paginationCount + 1}
                pageState={pageState}
                setPageState={setPageState}
                setShouldLoadData={setShouldLoadData}
              />
            </Stack>
          </div>
        </div>

        {/* {isOpenTxnDialog && (
          <ViewAndEditBankTransaction
            isOpenTxnDialog={isOpenTxnDialog}
            setIsOpenTxnDialog={setIsOpenTxnDialog}
            txnMode={txnMode}
            txnData={currentRow}
            navigatedFrom={NAVIGATION_PAGE_NAME.CASH_TRACKER}
          />
        )} */}

        <Dialog open={openCommentsDialog} onClose={handleCloseDialogs}>
          <DialogTitle>
            Comment
          </DialogTitle>
          <DialogContent sx={{ overflow: "hidden", textAlign: "center" }}>
            <TextareaAutosize
              minRows={5}
              value={dialogCommentsValue}
              onChange={handleDialogInputChange}
              className=""
              style={{ width: "350px", minWidth: "350px" }}
              // disabled={currentCommentsIndex!=selectedRowIndex}
            />
            {oldConcatenatedComment && (
              <div
                style={{
                  textWrap: "wrap",
                  backgroundColor: "rgb(175, 171, 170)",
                  marginTop: "10px",
                  padding: "20px",
                  borderRadius: "5px",
                  whiteSpace: "pre-wrap",
                  textAlign: "left",
                  maxHeight:"300px",
                  overflowY:"scroll",
                  maxWidth:"400px"
                }}
              >
                {oldConcatenatedComment}
              </div>
            )}
          </DialogContent>
          
          <DialogActions>
            <CommonButton
              text="Cancel"
              handleClick={handleCloseDialogs}
              sx={{
                backgroundColor: "#ffff",
                color: "#000000",
                border: "1px solid #BCBDBF",
              }}
            />
            <CommonButton
              text="Save"
              handleClick={handleSaveComments}
              hoverColor="#FF5A01"
              disabled={!dialogCommentsValue}
            />
          </DialogActions>
        </Dialog>

        {/* Follow up Audit Trail model */}
        {isAuditOpen && (
          <Dialog 
            open={isAuditOpen} 
            onClose={handleCloseDialogs} 
            maxWidth='lg'
            fullWidth
            sx={{ width: "100%", height: "80vh", marginTop: "5%" }}
          >
            <DialogTitle sx={{fontSize: "1.5rem"}}>Audit Trail</DialogTitle>
            <DialogContent sx={{ overflow: "hidden", height: "70vh" }}>
              <Grid container spacing={2} mt={2} paddingLeft={2}>
                <Grid item xs={12}>
                  <div style={{height: "50vh", overflowY: "auto"}}>
                    <table style={{width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr style={{ backgroundColor: '#f5f5f5' }}>
                          <th style={{ textAlign:'left', padding: '8px', border: '1px solid #ddd' }}>Changed Field</th>
                          <th style={{ textAlign:'left', padding: '8px', border: '1px solid #ddd' }}>Old Value</th>
                          <th style={{ textAlign:'left', padding: '8px', border: '1px solid #ddd' }}>New Value</th>
                          <th style={{ textAlign:'left', padding: '8px', border: '1px solid #ddd' }}>Changed By</th>
                          <th style={{ textAlign:'left', padding: '8px', border: '1px solid #ddd' }}>Last Edit Time</th>
                          {/* <th style={{ textAlign:'left', padding: '8px', border: '1px solid #ddd' }}>Timestamp</th> */}
                          <th style={{ textAlign:'left', padding: '8px', border: '1px solid #ddd' }}>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentRow && currentRow?.followup_audit_data?.map((audit, index) => (
                        <tr key={index}>
                            <td style={{ padding: '8px', border: '1px solid #ddd' }}>{audit?.field_name}</td>
                            <td style={{ padding: '8px', border: '1px solid #ddd' }}>{audit?.old_value}</td>
                            <td style={{ padding: '8px', border: '1px solid #ddd' }}>{audit?.new_value}</td>
                            <td style={{ padding: '8px', border: '1px solid #ddd' }}>{audit?.changed_by}</td>
                            <td style={{ padding: '8px', border: '1px solid #ddd' }}>{audit?.current_edit_datetime}</td>
                            {/* <td style={{ padding: '8px', border: '1px solid #ddd' }}>{audit.time_diff}</td> */}
                            <td style={{ padding: '8px', border: '1px solid #ddd' }}>{audit?.event_type === 'add' ? 'Added Follow Up' : audit.event_type}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <CommonButton
                text="Cancel"
                handleClick={handleCloseDialogs}
                sx={{
                  backgroundColor: "#ffff",
                  color: "#000000",
                  border: "1px solid #BCBDBF",
                }}
              />
            </DialogActions>
          </Dialog>
        )}
        </>
        ) : <div style={{paddingTop: "25%", textAlign: "center"}}>You are not authorized to view this page.</div>
      }
    </div>
  );
}
